import { sprintf } from "sprintf-js";
import { resizeCover } from "../../../../helpers";

export const formatStoryDataforStorySlides = (items, ngettext) => {
  let slides = [];

  slides.push(
    //continue reading slide
    {
      ...items[0].data[0],
      secondary_label: items[0].heading,
      type: items[0].type,
      progressBarAccessibility: progressBarAccessibility(
        items[0].data[0],
        ngettext
      )
    }
  );

  items.forEach((item, itemIndex) => {
    if (itemIndex === 0) {
      return;
    }

    item.data.forEach((story, storyIndex) => {
      slides.push({
        ...story,
        primary_label: storyIndex === 0 ? items[itemIndex].heading : "",
        leading_divider: storyIndex === 0 ? true : false,
        progressBarAccessibility: progressBarAccessibility(story, ngettext)
      });
    });
  });

  return slides;
};

export const progressBarAccessibility = (story, ngettext) => {
  let accessibitlyString = sprintf(
    ngettext("%s part read", "%s parts read", story.current_part.number),
    story.current_part.number
  );

  accessibitlyString += ", ";

  if (story.new_parts > 0) {
    accessibitlyString += sprintf(
      ngettext("%s new part", "%s new parts", story.new_parts),
      story.new_parts
    );
    accessibitlyString += ", ";
  }

  accessibitlyString += sprintf(
    ngettext("%s part total", "%s parts total", story.total_parts),
    story.total_parts
  );

  return accessibitlyString;
};

export const sizeStoryCover = (windowWidth, type, cover) =>
  windowWidth < 575
    ? type === "currentRead"
      ? resizeCover(cover, 50)
      : resizeCover(cover, 35)
    : type === "currentRead"
      ? resizeCover(cover, 95)
      : resizeCover(cover, 80);

export const slideSubLabel = (storyData, ngettext) =>
  storyData.new_parts != 0
    ? sprintf(
        ngettext("%s new part", "%s new parts", storyData.new_parts),
        storyData.new_parts
      )
    : sprintf(
        ngettext(
          "%s part left",
          "%s parts left",
          storyData.total_parts - storyData.current_part.number
        ),
        storyData.total_parts - storyData.current_part.number
      );
